import Vue from "vue";
import eventBusPlugin, { EventBus } from "@henrotaym/vue-event-bus";

Vue.use(eventBusPlugin);

/**
 * Application event bus.
 * 
 * @type {EventBus<import("@spa/types/bus").PackageEventBusEvents>}
 */
const bus = new EventBus();

export default bus;